import * as React from 'react';

import '../styles.scss';

import { ParagraphTextProps } from 'types/textProps';

const Paragraph = (props: ParagraphTextProps): React.JSX.Element => {
  const style =
    `text ${
      props.fontColor} ${
      props.fontSize}${
      props.bold ? ' --bold' : ''}${
      props.italic ? ' --italic' : ''}${
      props.underlined ? ' --underlined' : ''}${
      props.extraClasses ? ` ${props.extraClasses}` : ''
    }`;

  return (
    props.dangerouslySetInnerHTML ? (
      // eslint-disable-next-line react/no-danger
      <p className={style} data-testid={props.testId} dangerouslySetInnerHTML={{ __html: props.text }} />
    ) : (
      <p className={style} data-testid={props.testId}>
        {props.text}
      </p>
    )
  );
};

export default React.memo(Paragraph);
